import { http } from '@/services/api'

export interface ProjectPdfItem {
  id: string
  name: string
  filesize: number | null
  createdAt: string
  lastDownloadedAt: string | null
}

export interface UploadProjectPdfPayload {
  projectId: string
  userId: string
  filename: string
  blob: Blob
}

export async function uploadProjectPdf(
  payload: UploadProjectPdfPayload,
  refreshToken: string
): Promise<ProjectPdfItem> {
  const form = new FormData()
  form.append('projectId', payload.projectId)
  form.append('userId', payload.userId)
  form.append('file', payload.blob, payload.filename)

  const response = await http.post('/project-pdf', form, {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
  return response.data.pdf as ProjectPdfItem
}

export async function fetchProjectPdfs(projectId: string, refreshToken: string): Promise<ProjectPdfItem[]> {
  const response = await http.get('/project-pdf', {
    params: { projectId },
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
  return (response.data.pdfs as ProjectPdfItem[] | undefined) ?? []
}

export async function downloadProjectPdf(id: string, refreshToken: string): Promise<Blob> {
  const response = await http.get(`/project-pdf/${id}/file`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  })
  return response.data as Blob
}
